/**
 * English catalogs — the source of truth for every translatable string.
 *
 * Namespaces mirror the code layout, so a string's home is predictable from the
 * screen it appears on. Add a namespace here and in ../es/index.js at the same
 * time; NAMESPACES in ../../index.js is derived from this object's keys.
 */

import admin from './admin.json';
import analytics from './analytics.json';
import auth from './auth.json';
import badges from './badges.json';
import common from './common.json';
import drawings from './drawings.json';
import errors from './errors.json';
import legal from './legal.json';
import reports from './reports.json';
import settings from './settings.json';
import support from './support.json';

export default {
  admin,
  analytics,
  auth,
  badges,
  common,
  drawings,
  errors,
  legal,
  reports,
  settings,
  support,
};
